import GlobalVariable from '@/global/global-variable'

// 登录
const toLoginAPI = GlobalVariable.BASE_PATH + "/toLogin";
// 注册
const toRegisterAccountApi = GlobalVariable.BASE_PATH + "/toRegisterAccount";
// 获取公钥
const getPublicKeyApi = GlobalVariable.BASE_PATH + "/system/param/getPublicKey";

export default {
    // 登录
    toLoginAPI,
    // 注册
    toRegisterAccountApi,
    // 获取公钥
    getPublicKeyApi,
}



// WEBPACK FOOTER //
// ./src/request/api-login.js